
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { focus } from 'vue-focus'

@Component<ReceiveTextField>({
    directives: { focus },
})
export default class ReceiveTextField extends Vue {
    @Prop({ type: String }) public value!: string
    @Prop({ type: Boolean, default: false }) public shouldFocus!: boolean

    public submitReplyText(evt) {
        evt.preventDefault()
        this.$emit('submit-reply-text', evt.target.value)
    }

    public onKeyPress(evt) {
        if (evt.keyCode === 13 && evt.shiftKey) {
            this.submitReplyText(evt)
        }
    }

    public onInput(evt) {
        this.$emit('input', evt.target.value)
    }
}
